<div class="row">
  <div class="col-12">
    <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy table-sm">
  <thead>
    <tr>
      <th style="width: 25%" scope="col">Nota de Empenho</th>
      <th style="width: 10%" scope="col">Data</th>
      <th style="width: 10%" scope="col">Valor</th>
      <th style="width: 45%" scope="col">Fonte de Recursos</th>
      <th style="width: 10%" scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of entidade[campo]">
      <td style="width: 25%">
        <span *ngIf="!item.editavel">{{item.NumNotaEmpenho}}</span>
        <select *ngIf="item.editavel" [compareWith]="compareFn" class="form-control" [(ngModel)]="item.empenhoId"
          [ngModelOptions]="{standalone: true}" (change)="atribuirEmpenho()">
          <option *ngFor="let item of listaEmpenho" [ngValue]="item.id">
            {{item.numero}}/{{item.exercicio.ano}}
          </option>
        </select>
      </td>
      <td style="width: 10%">
        <span>{{item.NotaEmpenhoDt}}</span>
      </td>
      <td style="width: 10%">
        <span>{{item.NotaEmpenhoValor | number: '1.2-2'}}</span>
      </td>

      <td style="width: 45%">
        <span *ngIf="!item.editavel">{{funcaoService.obterNomePorChave(opcoesRecurso, item.FonteRecursos)}}</span>
        <select *ngIf="item.editavel" class="form-control" [(ngModel)]="item.FonteRecursos"
          [ngModelOptions]="{standalone: true}">
          <option *ngFor="let item of opcoesRecurso" [ngValue]="item.id">{{item.nome}}</option>
        </select>
      </td>

      <td style="width: 10%" class="text-right">
        <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>